import { StyleSheet } from 'aphrodite';
import { aceGray, shuffleGray } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	fallback: {
		alignItems: 'center',
		backgroundColor: shuffleGray,
		display: 'flex',
		fontSize: '1rem',
		height: '100%',
		justifyContent: 'center',
		lineHeight: 1,
		textTransform: 'uppercase',
		width: '100%',
	},
	image: {
		borderRadius: 'inherit',
		height: '100%',
		objectFit: 'cover',
		width: '100%',
	},
	root: {
		alignItems: 'center',
		backgroundColor: shuffleGray,
		border: `1px solid ${aceGray}`,
		borderRadius: '50%',
		display: 'inline-flex',
		justifyContent: 'center',
		overflow: 'hidden',
		userSelect: 'none',
		verticalAlign: 'middle',
		height: 60,
		width: 60,
	},
	smallText: {
		fontSize: 11,
	},
});
